import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
import labelText from '../../common/utils/labelText';
import ListingImageUploader from './ListingImageUploader';
const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  BRL: 'R$',
  CAD: 'C$',
  AUD: 'A$',
  CHF: 'CHF',
  CNY: '¥',
  INR: '₹',
  MXN: 'MX$',
  ZAR: 'R'
};
function symbolFor(currency) {
  if (!currency) return '';
  return CURRENCY_SYMBOLS[currency.toUpperCase()] || currency.toUpperCase();
}
export default class ListingComposerFields extends Component {
  view() {
    const composer = this.attrs.composer;
    const listing = composer.fields.listing = composer.fields.listing || {};
    const labels = (app.forum.attribute('classifiedsAllowedLabels') || 'iso,wtb,wts,trade').split(',').map(l => l.trim()).filter(Boolean);
    const allowRange = !!app.forum.attribute('classifiedsAllowPriceRange');
    const requireLabel = !!app.forum.attribute('classifiedsRequireLabel');
    const requirePrice = !!app.forum.attribute('classifiedsRequirePrice');
    const requireLocation = !!app.forum.attribute('classifiedsRequireLocation');

    // If the listing has no currency yet, fall back to the admin-configured
    // default — never let "R$" or any symbol stay hardcoded.
    const effectiveCurrency = listing.currency || app.forum.attribute('classifiedsDefaultCurrency') || '';
    const symbol = symbolFor(effectiveCurrency);
    listing.pendingImages = listing.pendingImages || [];
    listing.uploadedImages = listing.uploadedImages || [];
    return m("div", {
      className: "ClassifiedsComposer"
    }, m(ListingImageUploader, {
      pending: listing.pendingImages,
      uploaded: listing.uploadedImages,
      onChangePending: next => {
        listing.pendingImages = next;
      },
      onRemoveUploaded: url => {
        listing.uploadedImages = (listing.uploadedImages || []).filter(u => u !== url);
      }
    }), m("div", {
      className: "ClassifiedsComposer-pills",
      role: "radiogroup",
      "aria-label": app.translator.trans('flarum-classifieds.forum.composer.label_label', {}, true)
    }, labels.map(l => m("button", {
      key: l,
      type: "button",
      role: "radio",
      "aria-checked": listing.label === l,
      title: labelText(l),
      className: classList('Button Button--ua-reset ClassifiedsComposer-pill', listing.label === l && 'is-active', `ClassifiedsComposer-pill--${l.toLowerCase()}`),
      onclick: e => {
        e.preventDefault();
        listing.label = listing.label === l ? '' : l;
      }
    }, labelText(l))), requireLabel && !listing.label && m("span", {
      className: "ClassifiedsComposer-required",
      "aria-hidden": "true"
    }, "*")), m("div", {
      className: "ClassifiedsComposer-row"
    }, m("div", {
      className: "ClassifiedsComposer-priceInput",
      "data-symbol": symbol
    }, m("input", {
      className: "FormControl",
      type: "number",
      min: "0",
      step: "0.01",
      value: listing.price ?? '',
      oninput: e => listing.price = e.target.value,
      placeholder: app.translator.trans('flarum-classifieds.forum.composer.price_label', {}, true) + (requirePrice ? ' *' : ''),
      "aria-label": app.translator.trans('flarum-classifieds.forum.composer.price_label', {}, true)
    })), allowRange && m("div", {
      className: "ClassifiedsComposer-priceInput",
      "data-symbol": symbol
    }, m("input", {
      className: "FormControl",
      type: "number",
      min: "0",
      step: "0.01",
      value: listing.priceMax ?? '',
      oninput: e => listing.priceMax = e.target.value,
      placeholder: app.translator.trans('flarum-classifieds.forum.composer.price_max_label', {}, true),
      "aria-label": app.translator.trans('flarum-classifieds.forum.composer.price_max_label', {}, true)
    })), m("input", {
      className: "FormControl ClassifiedsComposer-currencyInput",
      type: "text",
      maxlength: 8,
      value: listing.currency || '',
      oninput: e => listing.currency = e.target.value.toUpperCase(),
      placeholder: app.forum.attribute('classifiedsDefaultCurrency') || app.translator.trans('flarum-classifieds.forum.composer.currency_label', {}, true),
      "aria-label": app.translator.trans('flarum-classifieds.forum.composer.currency_label', {}, true)
    }), m("input", {
      className: "FormControl ClassifiedsComposer-locationInput",
      type: "text",
      maxlength: 255,
      value: listing.location || '',
      oninput: e => listing.location = e.target.value,
      placeholder: app.translator.trans('flarum-classifieds.forum.composer.location_placeholder', {}, true) + (requireLocation ? ' *' : ''),
      "aria-label": app.translator.trans('flarum-classifieds.forum.composer.location_label', {}, true)
    })));
  }
}
flarum.reg.add('ramon-classifieds', 'forum/components/ListingComposerFields', ListingComposerFields);